import axios from 'axios';
import '@babel/polyfill';
import objectFitImages from 'object-fit-images';
import 'url-search-params-polyfill';
import './vendor/ie11CustomProperties';

window.axios = axios;
const ES6Promise = require('es6-promise');

// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// import 'core-js/es6/symbol';

// import svg4everybody from 'svg4everybody';

ES6Promise.polyfill();
objectFitImages();
